import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchDownloadHistories } from 'api/download-history.service';
import { DownloadHistoryModel } from 'types/entity';

export const DOWNLOAD_HISTORY_READ_STORE_NAME = 'downloadHistoryRead';

export const loadDownloadHistories = createAsyncThunk(
  `${DOWNLOAD_HISTORY_READ_STORE_NAME}/load`,
  async (projectId: string) => {
    const response = await fetchDownloadHistories(projectId);
    return response;
  },
);

export interface DownloadHistoryReadState {
  loaded: boolean
  entities: DownloadHistoryModel[]
  error: any
}

export const initialDownloadHistoryReadState: DownloadHistoryReadState = {
  loaded: false,
  entities: [],
  error: null,
};

export const downloadHistoryReadSlice = createSlice({
  name: DOWNLOAD_HISTORY_READ_STORE_NAME,
  initialState: initialDownloadHistoryReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadDownloadHistories.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadDownloadHistories.fulfilled, (state, action) => {
      state.loaded = true;
      state.entities = action.payload;
    });
    builder.addCase(loadDownloadHistories.rejected, (state, action) => {
      state.loaded = true;
      state.error = action.payload;
    });
  },
});

export const downloadHistoryReadAction = {
  ...downloadHistoryReadSlice.actions,
  loadDownloadHistories,
};

export default downloadHistoryReadSlice.reducer;
